import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { getOrganizations } from "actions"
import build from "redux-object"

import SubNav from "components/SubNav"
import Content from "components/Content"
import OrganizationsList from "components/organizations/List"
import NewOrganization from "components/organizations/New"
import EditOrganization from "components/organizations/Edit"
import Button from "components/forms/Button"
import Icon from "components/Icon"

class SettingsOrganizationsRoute extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newModalOpen: false,
      editModalOpen: false,
      clickedOrganizationId: null,
    }
  }

  componentDidMount() {
    this.props.getOrganizations()
  }

  handleRowClick = (event, rowInfo) => {
    event.preventDefault()
    const organizationId = rowInfo.original.id
    this.setState({
      editModalOpen: true,
      clickedOrganizationId: organizationId,
    })
  }

  closeModals = () => {
    this.setState({
      newModalOpen: false,
      editModalOpen: false,
      clickedOrganizationId: null,
    })
  }

  render() {
    const { organizations, loading, subNavOptions } = this.props
    const { newModalOpen, editModalOpen, clickedOrganizationId } = this.state

    return (
      <>
        <SubNav {...subNavOptions}>
          <Button
            kind="primary"
            onClick={() => this.setState({ newModalOpen: true })}
          >
            New Organization
            <Icon name="plus" width="12" height="12" />
          </Button>
        </SubNav>

        <Content>
          <OrganizationsList
            organizations={organizations}
            loading={loading}
            handleRowClick={this.handleRowClick}
          />
        </Content>

        {newModalOpen && <NewOrganization handleClose={this.closeModals} />}
        {editModalOpen &&
          <EditOrganization
            handleClose={this.closeModals}
            organizationId={clickedOrganizationId}
          />
        }
      </>
    )
  }
}

const mapStateToProps = state => {
  if(state.data.meta[`/organizations`]) {
    const organizations = (state.data.meta[`/organizations`].data || [])
      .map(object => build(state.data, 'organization', object.id))
    const loading = state.data.meta[`/organizations`].loading
    return { organizations, loading }
  }

  return { organizations: [], loading: true }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      getOrganizations,
    }, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsOrganizationsRoute)
